const Theme = {
  Dark: 'dark',
  Light: 'light'
}

export default Theme
